export default (id) => ({
  videoThumbnail: null,

  init() {
    fetch(`https://vimeo.com/api/v2/video/${id}.json`)
      .then((response) => {
        return response.text();
      })
      .then((data) => {
        this.videoThumbnail = JSON.parse(data)[0].thumbnail_large;
      })
      .catch((error) => {
        console.log(error);
      });
  },

  async imageSource() {
    return this.videoThumbnail;
  },
});
